<section class="about-section section">
    <div class="container">
        <div class="row">
            <div class="col-sm-4">
                <div class="heading">
                    <h3><b>About me</b></h3>
                    <h6 class="font-lite-black"><b></b></h6>
                </div>
            </div><!-- col-sm-4 -->
            <div class="col-sm-8">
                <p class="margin-b-50">Arquiteto de Soluções e Desenovlvedor, apaixonado por tecnologia.</p>
                <p class="margin-b-50">Atuando na área de desenolvimento de software desde 2006, onde passei por diversas empresas, atuei em diversos projetos e tive a oportunidade de evoluir profissionalmente</p>
            </div>
            
        </div><!-- row -->
    </div><!-- container -->
</section><!-- about-section -->

<section class="counter-section section">
    <div class="container">
        <div class="col-sm-12">
            <div class="row">
                <div class="col-lg-4 col-md-6 text-center">
                    <div class="service-box">
                        <i class="ion-code" style="font-size:90px;"></i>
                        <h3 style="color: #28023D"><b>Dev</b></h3>
                        <p style="color: #28023D"><b>Front e backend, Microserviço, games (hobbie) e outros</b></p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 text-center">
                    <div class="service-box">
                        <i class="ion-ios-cog" style="font-size:90px;"></i>
                        <h3 style="color: #28023D"><b>Soluções</b></h3>
                        <p style="color: #28023D"><b>Arquitetura de soluções, modernização, estratégias de migração, escalabilidade, redução de custos, etc</b></p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 text-center">
                    <div class="service-box">
                        <i class="ion-cloud" style="font-size:90px;"></i>
                        <h3 style="color: #28023D"><b>Cloud</b></h3>
                        <p style="color: #28023D"><b>Cloud Computing, conceitos de cloud publica com foco em AWS</b></p>
                    </div>
                </div>
            </div>
        </div><!-- col-sm-12 -->
        </div>
    </section><!-- about-section -->


<section class="experience-section section">
    <div class="container">
        <div class="row">
            <div class="col-sm-4">
                <div class="heading">
                    <h3><b>Work Experience</b></h3>
                    <h6 class="font-lite-black"><b>PREVIOUS JOBS</b></h6>
                </div>
            </div><!-- col-sm-4 -->
            <div class="col-sm-8">
            
                <div class="experience margin-b-50">
                    <h4><b>ARQUITETO DE SOLUÇÕES</b></h4>
                    <h5 class="font-yellow"><b>Itaú Unibanco</b></h5>
                    <h6 class="margin-t-10">Jun 2019 - Em andamento</h6>
                    <p class="font-semi-white margin-tb-30">Atuando no desenho de soluções para sistemas e serviços, com foco na modernização de novos sistemas e estratégias de estrangulamento para modernização dos sistemas legados para cloud publica e privada. </p>
                    <!--
                    <ul class="list margin-b-30">
                        <li>Duis non volutpat arcu, eu mollis tellus.</li>
                        <li>Quis consequat nulla effi citur at.</li>
                        <li>Sed finibus aliquam neque sit.</li>
                    </ul>-->
                </div><!-- experience -->
                
                <div class="experience margin-b-50">
                    <h4><b>ANALISTA DESENVOLVEDOR</b></h4>
                    <h5 class="font-yellow"><b>MSC - Mediterranean Shipping</b></h5>
                    <h6 class="margin-t-10">Out 2011 - Jun 2019</h6>
                    <p class="font-semi-white margin-tb-30">Atuando no desenvolvimento de novos projetos, utilizando tecnologias Microsoft (C#, ASP.NET, Windows Forms e WCF) e banco de dados SQL Server e SQLite. </p>
                    <!--
                    <ul class="list margin-b-30">
                        <li>Duis non volutpat arcu, eu mollis tellus.</li>
                        <li>Quis consequat nulla effi citur at.</li>
                        <li>Sed finibus aliquam neque sit.</li>
                    </ul>-->
                </div><!-- experience -->

                <div class="experience margin-b-50">
                    <h4><b>ANALISTA DESENVOLVEDOR</b></h4>
                    <h5 class="font-yellow"><b>Unimed Paulistana</b></h5>
                    <h6 class="margin-t-10">Nov 2007 - Out 2011</h6>
                    <p class="font-semi-white margin-tb-30">Atuando como analista desenvolvedor, criando novos projetos e manutenção de sistemas legado utilizando C#, ASP, ASP.NET, Windows Forms, Webservices, ASP.NET MVC, Jquery, Jquery Mobile e banco de dados Oracle e SQL Server. </p>
                    <!--
                    <ul class="list margin-b-30">
                        <li>Duis non volutpat arcu, eu mollis tellus.</li>
                        <li>Quis consequat nulla effi citur at.</li>
                        <li>Sed finibus aliquam neque sit.</li>
                    </ul>-->
                </div><!-- experience -->
                
            </div><!-- col-sm-8 -->
        </div><!-- row -->
    </div><!-- container -->
    
</section><!-- experience-section -->

<section class="education-section section">
    <div class="container">
        <div class="row">
            <div class="col-sm-4">
                <div class="heading">
                    <h3><b>Pesquisa</b></h3>
                    <h6 class="font-lite-black"><b>-</b></h6>
                </div>
            </div><!-- col-sm-4 -->
            <div class="col-sm-8">
                <div class="education-wrapper">
                    <div class="education margin-b-50">
                        <h4><b>Pesquisa Home Office</b></h4>
                        <h5 class="font-yellow"><b>Como anda seu trabalho remoto durante essa pandemia?</b></h5>
                        <a href="/pesquisahomeoffice"><h6 class="font-lite-black margin-t-10">O isolamento social causado pelo Coronavírus fez com que as empresas acelerassem o processo de trabalho em Home Office. Gostaria de saber sua opinião referente à como está seu trabalho em Home Office. Clique em qualquer parte do texto para participar da pesquisa</h6></a>
                        <!--<p class="margin-tb-30">Duis non volutpat arcu, eu mollis tellus. Sed finibus aliquam neque sit amet sodales. 
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla maximus pellentes que velit, 
                        quis consequat nulla effi citur at. Maecenas sed massa tristique.Duis non volutpat arcu, 
                        eu mollis tellus. Sed finibus aliquam neque sit amet sodales. </p>-->
                    </div><!-- education -->
                    
                </div><!-- education-wrapper -->
            </div><!-- col-sm-8 -->
        </div><!-- row -->
    </div><!-- container -->
    
</section><!-- about-section -->


<section class="counter-section" id="counter">
    <div class="container">
        <div class="row">
        
            <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="counter margin-b-30">
                    <h1 class="title"><b><span class="counter-value" data-duration="400" data-count="3">0</span></b></h1>
                    <h5 class="desc"><b>Coder Degrees</b></h5>
                </div><!-- counter -->
            </div><!-- col-md-3-->
            
            <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="counter margin-b-30">
                    <h1 class="title"><b><span class="counter-value" data-duration="1400" data-count="25">0</span></b></h1>
                    <h5 class="desc"><b>Project Completed</b></h5>
                </div><!-- counter -->
            </div><!-- col-md-3-->
            
            <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="counter margin-b-30">
                    <h1 class="title"><b><span class="counter-value" data-duration="700" data-count="311">0</span></b></h1>
                    <h5 class="desc"><b>Satisfied Clients</b></h5>
                </div><!-- counter -->
            </div><!-- col-md-3-->
            
            <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="counter margin-b-30">
                    <h1 class="title"><b><span class="counter-value" data-duration="2000" data-count="732">0</span></b></h1>
                    <h5 class="desc"><b>Finished Projects</b></h5>
                </div><!-- margin-b-30 -->
            </div><!-- col-md-3-->
            
        </div><!-- row-->
    </div><!-- container-->
</section><!-- counter-section-->
